// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__3UWLW","bigtitle":"styles_bigtitle__V3V5M","content":"styles_content__OqIIZ","title":"styles_title__eyhKZ"};